import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { Page } from '../../../models/list/page.model';
import { ListMemberService } from './list-member.service';
import { AddMemberPopupComponent } from './add-member-popup.component';
import { DialogService } from '../../../shared/services/dialog.service';
import { ValidationService } from '../../../shared/services/validation.service';
import { AddTMBStaffPopupComponent } from './add-tmb-staff-popup.component';
import { ImportFormModel, BookingDetailsModel, AddTMBStaffModel } from '../../../models/booking/booking-details.model';
import { PartyType } from '../../../models/consultation/cash-sale.model';
import { Router } from '@angular/router';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';
import { SharedService } from '../../../shared/services/share.services';
@Component({
    selector: 'list-member',
    templateUrl: 'list-member.component.html',
    providers: [ListMemberService]
})

export class ListMemberComponent extends TMBDataTableComponent implements OnInit {
    public fileErrorMessage = ValidationService.getValidatorErrorMessage('invalidExelFile');
    public dataMemberMessage = {
        emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
        totalMessage: AppMessages.list.total
    };
    public dataTMBStaffMessage = {
        emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
        totalMessage: AppMessages.list.total
    };
    public appConstants = AppConstants;
    public dataMember = [];
    public dataStaff = [];
    public url: string;
    public fileImport: File = null;
    public listMemberForm: FormGroup;
    public listMemberModel = new ImportFormModel();
    public bookingMemberModel = new BookingDetailsModel();
    public partyType = PartyType;
    public isHidden = false;
    public tmbPage = new Page();
    constructor(private formBuilder: FormBuilder,
        private router: Router,
        public listMemberService: ListMemberService,
        public sharedService: SharedService,
        public dialogService: DialogService,
        public utility: Utility
    ) {
        super(sharedService);
    }
    ngOnInit() {
        this.page.size = this.tmbPage.size = 5;
        this.page.totalElements = this.tmbPage.totalElements = 5;
        this.page.totalPages = this.tmbPage.totalPages = 1;
        this.page.pageNumber = this.tmbPage.pageNumber = 0;
        this.createForm();
        this.listMemberService.getBookingCache().subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    if (data !== null && data !== undefined) {
                        this.bookingMemberModel = data;
                    }
                    if (data['isChangeType'] === true) {
                        this.dataMember = [];
                    } else {
                        if (this.bookingMemberModel.listMembers != null) {
                            this.bookingMemberModel.listMembers.forEach(element => {
                                element.name = element.firstName + " " + element.surName;
                                element.address = element.address1 + ", " + element.address2;
                                this.dataMember.push(element);
                            });
                        }
                        if (this.bookingMemberModel.staffs != null) {
                            this.dataStaff = this.bookingMemberModel.staffs;
                        }
                    }
                }
            }, error => {
                this.dialogService.openErrorDialog({ message: error });
            }
        );
        this.listMemberService.downloadFileTemplate().subscribe(
            result => {
                if (result) {
                    this.url = result.url;

                } else {
                    this.url = '';
                }
            }
        );
    }

    setHidden() {
        if (this.bookingMemberModel.bookingType === this.partyType.Individual && this.dataMember.length > 0) {
            this.isHidden = true;
            return this.isHidden;
        }
        this.isHidden = false;
        return this.isHidden;
    }

    createForm() {
        this.listMemberForm = this.formBuilder.group({
            IsFileDelete: [''],
            FileName: [''],
            members: [this.dataMember]
        });
    }

    onOpenDialogAddMember() {
        const data = {
            dataMember: this.dataMember,
            bookingType: this.bookingMemberModel.bookingType
        };
        const form = new FormControl('');
        this.dialogService.openComponentDialog(AddMemberPopupComponent, data, {
            'width': window.screen.width <= 400 ? '450px' : '80%', panelClass: 'override-popup'
        }).subscribe(
            result => {
                if (result) {
                    if (this.bookingMemberModel.bookingType === this.partyType.Individual
                    ) {
                        result[0].mainContact = true;
                    }
                    if (this.bookingMemberModel.bookingType === this.partyType.FluVaccine) {
                        result.forEach(element => {
                            element.mainContact = true;
                        });
                    }
                    this.dataMember = this.dataMember.concat(result);
                    // sort dataMember name alphabetically
                    this.dataMember.sort((a, b) =>
                        (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
                    this.setHidden();
                }
            }
        );
    }

    onRemoveMember(row, page: Page) {
        // call api remove patient
        const index = this.dataMember.indexOf(row);
        this.dataMember.splice(index, 1);
        page = this.checkPage(this.dataMember, page);
        this.setPage(this.page, {
            offset: page.pageNumber,
            pageSize: page.size,
            count: page.totalElements,
            limit: page.totalPages
        });
        this.setHidden();

    }

    checkPage(dataMember: Array<any>, page: Page) {
        if (page) {
            if (page.pageNumber > 0) {
                if ((dataMember.length % page.size) === 0) {
                    page.pageNumber -= 1;
                }
            }
        }
        return page;
    }

    setPage(page: Page, event) {
        if (event) {
            page.pageNumber = event.offset;
            page.size = event.pageSize;
            page.totalElements = event.count;
            page.totalPages = event.limit;
        }
    }

    onRemoveStaffTMB(row, page: Page) {
        const index = this.dataStaff.indexOf(row);
        this.dataStaff.splice(index, 1);
        page = this.checkPage(this.dataStaff, page);
        this.setPage(this.tmbPage, {
            offset: page.pageNumber,
            pageSize: page.size,
            count: page.totalElements,
            limit: page.totalPages
        });
    }

    onMainContact(row, event) {
        if (event.checked) {
            row.mainContact = true;
        } else {
            row.mainContact = false;
        }
    }

    onChangeFlie(event) {
        if (event) {
            const fileList: FileList = event.target.files;
            if (fileList.length > 0) {
                const file: File = fileList[0];
                if (this.utility.isValidFile(file, AppConstants.uploadFileConfig.exel, 2)) {
                    this.fileImport = file;
                    // hide choose file button
                    event.target.hidden = true;
                    this.listMemberForm.controls['IsFileDelete'].setValue(false);
                    this.listMemberForm.controls['FileName'].setValue(this.fileImport.name);
                } else {
                    // show error popup
                    this.dialogService.openErrorDialog({ message: this.fileErrorMessage });
                }
            }
        }
    }

    onRemoveFile(event) {
        this.listMemberForm.controls['IsFileDelete'].setValue(true);
        this.listMemberForm.controls['FileName'].setValue('');
        this.fileImport = null;
        this.listMemberModel.fileName = '';
        // get input file and set value to null
        const fileInput = event.target.parentElement.parentElement.nextElementSibling.nextElementSibling;
        fileInput.value = '';
    }

    onOpenDialogAddStaff() {
        const data = {
            dataStaff: this.dataStaff || new Array<AddTMBStaffModel>()
        };
        this.dialogService.openComponentDialog(AddTMBStaffPopupComponent, data).subscribe(
            result => {
                if (result) {
                    // this.dataStaff = result || [];
                    result.forEach(element => {
                        if (!this.dataStaff.find(x => x.staffName === element.staffName)) {
                            this.dataStaff.push(element);
                        }
                    });
                }
            });
    }

    importFile() {
        // import file date in table
        if (this.fileImport) {
            const formData = new FormData();
            formData.append('excelFile', this.fileImport, this.fileImport.name);
            this.dataMember = [];
            this.listMemberService.importFileMember(formData).subscribe(
                result => {
                    if (result) {
                        const data = result.json();
                        const data1 = data['list'];
                        if (data1 === []) {
                            this.dialogService.openErrorDialog({ message: data.message });
                        } else {
                            data1.forEach(element => {
                                if (this.bookingMemberModel.bookingType == this.partyType.FluVaccine) {
                                    element.mainContact = true;
                                }
                                this.dataMember.push(element);
                            });
                            this.dialogService.openSuccessDialog({ message: data.message });
                        }
                    }
                }
            );
        }
    }

    onBookAppointment() {
        if (this.dataMember.length < 2) {
            this.dialogService.openErrorDialog({ message: AppMessages.listMemberBooking.errorBookAppointment });
        } else if (this.dataStaff.length < 1) {
            this.dialogService.openErrorDialog({ message: AppMessages.listMemberBooking.errorTMBStaffBookAppointment });
        } else {
            if (this.isDuplicate()) {
                this.dialogService.openErrorDialog({ message: AppMessages.listMemberBooking.uniquePatient });
                return;
            }
            this.bookingMemberModel.listMembers = this.dataMember;
            this.bookingMemberModel.staffs = this.dataStaff;
            this.bookingMemberModel.IsSaveFluBooking = true;
            this.listMemberService.addBooking(this.bookingMemberModel).subscribe(
                (result) => {
                    if (result) {
                        const data = result.json();
                        this.dialogService.openSuccessDialog({ message: data.message.message });
                        this.router.navigate(['booking/manage-booking']);
                    }
                }
            );
        }
    }

    isDuplicate(): boolean {
        const uniq = this.dataMember
            .map(x => {
                return { count: 1, name: x.name.toLowerCase(), dateOfBirth: x.dateOfBirth };
            })
            .reduce((a, b) => {
                const str = b.name + b.dateOfBirth.toString();
                a[str] = (a[str] || 0) + b.count;
                return a;
            }, {});
        const duplicate = Object.keys(uniq).filter(x => uniq[x] > 1);
        return duplicate.length > 0;
    }

    onViewCalendar() {
        if (this.dataMember.length < 1) {
            this.dialogService.openErrorDialog({ message: AppMessages.listMemberBooking.errorViewCalendar });
            return;
        }
        if (this.dataMember.length < 2 && this.bookingMemberModel.bookingType == this.partyType.Group) {
            this.dialogService.openErrorDialog({ message: AppMessages.listMemberBooking.errorMemberGroup });
            return;
        } if (this.dataMember.length > 1 && this.bookingMemberModel.bookingType == this.partyType.Individual) {
            this.dialogService.openErrorDialog({ message: AppMessages.listMemberBooking.errorMemberIndividual });
            return;
        }
        if (this.bookingMemberModel.bookingType === this.partyType.Group) {
            if (this.isDuplicate()) {
                this.dialogService.openErrorDialog({ message: AppMessages.listMemberBooking.uniquePatient });
                return;
            }
        }
        const checkAnyMainContactChecked = this.dataMember.findIndex(x => x.mainContact === true);
        if (checkAnyMainContactChecked < 0) {
            return this.dialogService.openErrorDialog({ message: AppMessages.listMemberBooking.errorViewCalendar });
        }
        this.bookingMemberModel.listMembers = this.dataMember;
        this.listMemberService.addBookingCache(this.bookingMemberModel).subscribe(
            result => {
                if (result) {
                    this.router.navigate(['booking/manage-booking']);
                }
            }
        );
        /*  this.listMemberService.addNewMembers(this.listMemberForm.value).subscribe(
              result => {
                  if (result) {
                      this.listMemberService.getNewMemberCache().subscribe(
                          result => {
                              if (result) {
                                  const data = result.json();
                              }
                          }
                      );
                  }
              }
          ); */

    }

    onBack() {
        this.bookingMemberModel.listMembers = this.dataMember;
        this.bookingMemberModel.IsSaveFluBooking = false;
        this.bookingMemberModel.staffs = this.dataStaff;
        this.listMemberService.addBookingCache(this.bookingMemberModel).subscribe(
            result => {
                if (result) {
                    this.router.navigate(['booking/request-appointment']);
                }
            }
        );
    }

    /**
     * overwrite fucntion in TMBDataTableComponent
     */
    updateTableLayout() {
        // refresh the layout
        this.dataMember = [...this.dataMember];
        this.dataStaff = [...this.dataStaff];
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/booking/list-member/list-member.component.ts